import { MatDialogRef } from '@angular/material/dialog';
import { PencilModalSizeEnum } from './modal-template/modal-template.component';

/**
 * MAT_DIALOG_DATA shape every ShellDialogBase subclass should carry.
 *
 */
export interface ShellDialogData {
  description?: string;
  size?: PencilModalSizeEnum;
  dismissable?: boolean;
}

/**
 * Shared plumbing for dialogs built on ModalTemplateComponent, always opened via
 * `MatDialog.open()`. No bottom-sheet/direct-embed support — add only when a real mobile design
 * needs it.
 *
 * Subclasses read `this.data` directly and define their own DI-decorated constructor,
 * forwarding to `super(...)`.
 */
export abstract class ShellDialogBase<TComponent, TData extends ShellDialogData, TCloseResult = string> {
  protected readonly data: TData;

  constructor(
    protected dialogRef: MatDialogRef<TComponent, TCloseResult>,
    matDialogData: TData,
    defaults?: Partial<TData>,
  ) {
    this.data = { ...defaults, ...matDialogData };
    this.dialogRef._containerInstance._config.autoFocus = false;
  }

  protected close(result: TCloseResult): void {
    this.dialogRef.close(result);
  }
}
